export default "__VITE_ASSET__NJ_rRNeC__"